var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.redirectInCardsPage)?_c('van-button',{staticClass:"BackToAct-btn",attrs:{"block":"","round":"","type":"info"},on:{"click":_vm.go_act}},[_vm._v("立即兑换")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }